module.exports = {
  dimensions: {
    width: 15,
    height: 15
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};